var map = {
	"./ar.json": "4MTb",
	"./az.json": "Fcqy",
	"./bg.json": "OMA2",
	"./bn.json": "NafH",
	"./cs.json": "ETox",
	"./de.json": "uCfg",
	"./el.json": "8Yju",
	"./en.json": "8qhO",
	"./es.json": "jm+J",
	"./et.json": "GbpK",
	"./fr.json": "r5/M",
	"./he.json": "TlZJ",
	"./hi.json": "XEQp",
	"./hr.json": "L79u",
	"./hu.json": "uaj/",
	"./id.json": "LZnx",
	"./it.json": "844t",
	"./ja.json": "KsCF",
	"./kk.json": "JU+h",
	"./ko.json": "8nuZ",
	"./lv.json": "T7ee",
	"./nl.json": "MBIY",
	"./pl.json": "1/3s",
	"./pt.json": "4F09",
	"./pt_BR.json": "oObB",
	"./ro.json": "Zhr8",
	"./ru.json": "OF0E",
	"./sk.json": "pGZ5",
	"./sq.json": "+iZ8",
	"./sv.json": "RGBA",
	"./th.json": "3Et9",
	"./tr.json": "j+Zm",
	"./ur.json": "t2ZL",
	"./vi.json": "5rt5",
	"./zh.json": "CgjZ"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "UeJB";